import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const Hero = ({ images = [] }) => {
    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 2000,
    };
    return (
        <div
            className="object-cover w-full mt-0 sm:mt-10  sm:p-4"
        >
            <Slider {...settings} className="overflow-hidden w-full ">
                {images.map((img, x) => (
                    <img
                        key={x}
                        src={img}
                        alt=""
                        className="object-contain rounded-md"
                    />
                ))}
            </Slider>
        </div>
    );
};

export default Hero;
